"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabList = void 0;
const react_1 = __importDefault(require("react"));
const Tab_1 = require("../../atoms/Tab/Tab");
const TabList = ({ tabs, size }) => {
    return (react_1.default.createElement("div", { className: "flex" }, react_1.default.Children.toArray(tabs.map((tab) => tab.type === 'button' ? (react_1.default.createElement(Tab_1.TabButton, { key: tab.label, onClick: tab.onClick, active: tab.active, size: size, className: "flex-grow" }, tab.label)) : (react_1.default.createElement(Tab_1.TabLink, { key: tab.label, to: tab.to, active: tab.active, size: size, className: "flex-grow" }, tab.label))))));
};
exports.TabList = TabList;
